import React from 'react';

export function sanitizeHtml(html) {
  if (typeof html !== 'string') return '';

  // 1. Remove script tags and their content
  let clean = html.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, '');

  // 2. Remove event handlers (onmouseover, onload, onerror, etc.) from any tags
  clean = clean.replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '');

  // 3. Remove javascript: URIs in href
  clean = clean.replace(/href\s*=\s*['"]\s*javascript:[^'"]*['"]/gi, 'href="#"');

  return clean;
}

export function SafeHtmlError({ message, className = 'text-danger text-center' }) {
  if (!message) return null;

  const isHtml = typeof message === 'string' && message.trim().startsWith('<');
  if (isHtml) {
    const cleanHtml = sanitizeHtml(message);
    return <div className={className} dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
  }

  return <div className={className}>{message}</div>;
}

export default SafeHtmlError;
